<template lang="pug">
span
  span(@click="modal_open")
    slot(name="activator")
  v-dialog.d-inline(v-model="isModalVisible" persistent max-width="480")
    v-card
      title-bar(dark) {{ title }}
      v-card-text
        v-select(:items="hotnesses" v-model="selectedHotness" label="Select A Contact Hotness")
          template(slot="item" slot-scope="data")
            v-list-tile
              v-list-tile-content
                v-list-tile-title(v-text="data.item.text")
                v-list-tile-sub-title(v-text="data.item.description")

      v-card-actions
        v-spacer
        v-btn(flat @click="modal_close") Cancel
        v-btn.primary(@click="save" :disabled="!canSave") Save

</template>

<script>
import TitleBar from '@/Core/components/TitleBar';
import Modal from '@/Core/mixins/modal';

export default {
  components: {
    TitleBar,
  },
  mixins: [Modal],
  props: {
    contactUpdateActionPayload: {
      type: Function,
    },
    patchContacts: {
      type: Function,
    },
    hotnesses: {
      type: Array,
      required: true,
    },
    selectedIds: {
      type: Array,
      required: true,
    },
    totalContactsSelected: {
      type: Number,
    },
  },
  computed: {
    title() {
      if (this.selectedIds.length === 1) {
        return 'Edit Hotness for Contact';
      }
      return `Edit Hotness for ${this.totalContactsSelected} Contacts`;
    },
    canSave() {
      return this.selectedHotness !== null;
    },
  },
  data() {
    return {
      selectedHotness: null,
    };
  },
  methods: {
    async save() {
      const action = this.contactUpdateActionPayload({hotness_id: this.selectedHotness});
      const payload = {
        action,
        selected: this.selectedIds
      };
      this.modal_close();
      await this.patchContacts(payload);
      this.$emit('deselect-all');
      this.$emit('contact-updated');
      this.selectedHotness = null;
    },
  },
};
</script>
